/* eslint-disable import/no-duplicates */
import React, { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import Input from "components/Input";
import {
  CheckBox as CheckBoxIcon,
  Receipt as ReceiptIcon,
  LocalShipping as LocalShippingIcon,
  FilterList as FilterListIcon,
  Search as SearchIcon,
  Close as CloseIcon,
} from "@mui/icons-material";

import { format } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";
import {
  Typography,
  Button,
  SwipeableDrawer,
  InputAdornment,
  Box,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Modal,
  Drawer,
} from "@mui/material";
import { SlideModal } from "ctech-react-components";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import { handleUpdateOrderRequest } from "store/modules/Orders/thunk.store";
import { useAppDispatch } from "store/hooks";
import {
  OrderProps,
  OrderUpdateActions,
  OrderUpdateActionsEnum,
} from "store/modules/Orders/types.store";

import useStateCallback from "hooks/UseStateCallback";

import getOrderModalsProps from "utils/getOrderModalsProps";

import { TabsNavigation } from "ctech-react-components";
import CardOrder from "./componentsNew/CardOrder";
import ModalOrderManagement from "./components/ModalOrderManagement";

import * as Styled from "./styles";
import { useOrders } from "./useOrders";
import CardOrderDetails from "./componentsNew/CardOrderDetails";
import CancelOrderModal from "./components/CancelOrderModal";
import { useForm } from "react-hook-form";
import dealerCareApi from "services/dealerCareApi";
import { formatTaxDocument, stripTaxDocumentMask } from "utils/taxDocument";
import inputCode from "assets/supergasbras/images/inputCode.png";
import reasonCodePin from "assets/supergasbras/images/reasonCodePin.png";
import { OtpInput } from "reactjs-otp-input";

interface DealerResponse {
  tradeName: string;
  id: string;
  taxpayerId: string;
}

const OrderManagement: React.FC = () => {
  const [currentTab, setCurrentTab] = useState("1");
  const [modal, setModal] = useState(false);
  const [ordersSelected, setOrdersSelected] = useState<number | null>(null);

  const [isConfirmationModalVisible, setIsConfirmationModalVisible] =
    useState(false);
  const [confirmationModalProps, setConfirmationModalProps] = useStateCallback(
    getOrderModalsProps(),
  );
  const [isLoadingSearchDealerByTerm, setIsLoadingSearchDealerByTerm] =
    useState(false);
  const [foundDealers, setFoundDealers] = useState<null | DealerResponse[]>(
    null,
  );
  const [tempSelectedDealer, setTempSelectedDealer] = useState<null | Omit<
    DealerResponse,
    "taxpayerId"
  >>(null);
  const [selectedDealer, setSelectedDealer] = useState<null | Omit<
    DealerResponse,
    "taxpayerId"
  >>(null);

  const [isSwipeableOpen, setIsSwipeableOpen] = useState(false);

  const {
    register,
    formState: { errors },
    handleSubmit,
    watch,
  } = useForm<{ reseller: string }>();

  const resellerData = watch("reseller");

  const [modalProps, setModalProps] = useState<{
    orderId: string;
    dealerId: string;
    consumerId: string;
    type: OrderUpdateActions;
    paymentType: string;
    valeGas: boolean;
  } | null>(null);

  const [dataOrderModal] = useState<OrderProps | null>();

  const { t } = useTranslation();

  const getOrderType = useCallback((tab: string) => {
    switch (tab) {
      case "1":
        return "New";
      case "2":
        return "InProgress";
      default:
        return "Finalized";
    }
  }, []);

  const {
    typeOrders,
    openModalCode,
    setOpenModalCode,
    setOpenModalFinallyOrder,
    openModalFinallyOrderDescription,
    setOpenModalFinallyOrderDescription,
  } = useOrders(selectedDealer?.id || null);

  const enabledPin = process.env.REACT_APP_ENABLE_PIN_ORDER;
  const [otp, setOtp] = useState("");
  const [reasonNotProvidePin, setReasonNotProvidePin] = useState("");
  const handleChange = useCallback((otpValue: string) => setOtp(otpValue), []);

  const handleChangeTab = useCallback(
    async (_: React.SyntheticEvent, newValue: string) => {
      setCurrentTab(newValue);
      setOrdersSelected(null);
    },
    [],
  );

  const closeOrderManagement = useCallback(() => {
    setModalProps(null);
    setOrdersSelected(null);
    setModal(false);
  }, []);

  const handleCloseSwipeable = useCallback((noReset?: boolean) => {
    if (!noReset) {
      setFoundDealers(null);
      setTempSelectedDealer(null);
    }

    setIsSwipeableOpen(false);
  }, []);

  const handleChangeConfirmationModalVisibility = useCallback(() => {
    setIsConfirmationModalVisible((state) => {
      if (state) setConfirmationModalProps(getOrderModalsProps());

      return !state;
    });
  }, [setConfirmationModalProps]);

  const dispatch = useAppDispatch();

  const handleOrderUpdate = useCallback(
    (
      type: OrderUpdateActions,
      orderId: string,
      dealerId: string,
      paymentType: string,
      valeGas: boolean,
      consumerId?: string,
    ) => {
      // Determina qual tab deve ser ativada baseado no tipo de order
      const order =
        typeOrders("New").find((o) => o.id === orderId) ||
        typeOrders("InProgress").find((o) => o.id === orderId) ||
        typeOrders("Finalized").find((o) => o.id === orderId);

      if (order) {
        if (typeOrders("New").find((o) => o.id === orderId)) {
          setCurrentTab("1");
        } else if (typeOrders("InProgress").find((o) => o.id === orderId)) {
          setCurrentTab("2");
        } else if (typeOrders("Finalized").find((o) => o.id === orderId)) {
          setCurrentTab("3");
        }
      }

      setModalProps({
        orderId,
        type,
        dealerId,
        paymentType,
        valeGas,
        consumerId: consumerId || "",
      });
    },
    [typeOrders],
  );

  const modalRender = useMemo(() => {
    if (!modalProps) {
      // eslint-disable-next-line react/jsx-no-useless-fragment
      return <></>;
    }

    const onClose = () => setModalProps(null);
    const onConfirm = async (state?: unknown) => {
      await dispatch(
        handleUpdateOrderRequest({
          dealerId: modalProps.dealerId,
          type: modalProps.type,
          orderId: modalProps.orderId,
          body: enabledPin === "true" ? state : undefined,
          consumerId: modalProps.consumerId,
          platform: "WEB",
          reasonNotProvidePin:
            modalProps.type === OrderUpdateActionsEnum.FINALIZE &&
            reasonNotProvidePin.length &&
            enabledPin === "true"
              ? reasonNotProvidePin
              : undefined,
          pin:
            modalProps.type === OrderUpdateActionsEnum.FINALIZE &&
            otp.length &&
            enabledPin === "true"
              ? otp
              : undefined,
        }),
      )
        .unwrap()
        .finally();
      setReasonNotProvidePin("");
      setOtp("");
      setOpenModalFinallyOrderDescription(false);
      setOpenModalFinallyOrder(false);
      onClose();
    };

    const isCancelType = modalProps.type === OrderUpdateActionsEnum.CANCEL;
    const isDenyType = modalProps.type === OrderUpdateActionsEnum.DENY;
    const isFinallyType = modalProps.type === OrderUpdateActionsEnum.FINALIZE;

    if (isCancelType) {
      return (
        <CancelOrderModal
          labelType="CANCEL"
          isOpen={!!modalProps}
          onClose={onClose}
          onConfirm={onConfirm}
          onCloseOrderModal={closeOrderManagement}
        />
      );
    }
    if (isDenyType) {
      return (
        <CancelOrderModal
          labelType="DENY"
          isOpen={!!modalProps}
          onClose={onClose}
          onConfirm={onConfirm}
          onCloseOrderModal={closeOrderManagement}
        />
      );
    }

    return enabledPin === "true" &&
      isFinallyType &&
      (modalProps.paymentType === "INAPP" || modalProps?.valeGas) ? (
      <Modal
        open={enabledPin === "true"}
        onClose={() => {
          setOpenModalFinallyOrder(false);
          onClose();
          setReasonNotProvidePin("");
        }}
        style={{
          zIndex: 1500,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {openModalFinallyOrderDescription ? (
          <Styled.ContentModalOTP>
            <Styled.TitleHeaderCode>
              <Typography variant="body2">
                {" "}
                <ArrowBackIcon />
                Atenção
              </Typography>

              <Styled.ButtonClose
                onClick={() => {
                  setOpenModalFinallyOrder(false);
                  onClose();
                }}
              />
            </Styled.TitleHeaderCode>

            <Styled.Image src={reasonCodePin} />

            <Styled.TitleBodyCodeOtp>
              <Typography
                variant="body2"
                textAlign="center"
                style={{ width: "380px" }}
                sx={{
                  fontSize: "15px",
                }}
              >
                Caso o cliente sinalize o não recebimento do pedido, o valor
                será reembolsado integralmente e essa venda será perdida
              </Typography>
            </Styled.TitleBodyCodeOtp>
            <Styled.ContainerTextField>
              <Styled.InputLabelContainer shrink htmlFor="reasonDescription">
                Motivo
              </Styled.InputLabelContainer>
              <Styled.TextFieldReason
                placeholder="Descreva o motivo de fechar o pedido sem código."
                onChange={(e) => setReasonNotProvidePin(e.target.value)}
                inputProps={{ maxLength: 150 }}
                sx={{
                  paddingBottom: "15px",
                  textTransform: "inherit",
                }}
              />
              <Typography
                variant="caption"
                color="textSecondary"
                sx={{
                  position: "absolute",
                  bottom: 12,
                  right: 0,
                  fontSize: "0.8rem",
                }}
              >
                {`${reasonNotProvidePin.length}/${150}`}
              </Typography>
            </Styled.ContainerTextField>

            <Styled.ContainerButton>
              <Styled.ButtonModalCode
                onClick={() => {
                  setOpenModalFinallyOrderDescription(false);
                  setReasonNotProvidePin("");
                }}
                color="primary"
                variant="outlined"
                size="large"
              >
                VOLTAR
              </Styled.ButtonModalCode>
              <Styled.ButtonModalCode
                onClick={() => {
                  onConfirm({
                    origin: "DealerPortal",
                  });
                }}
                disabled={reasonNotProvidePin?.length < 4}
                color="primary"
                variant="contained"
                size="large"
              >
                FINALIZAR
              </Styled.ButtonModalCode>
            </Styled.ContainerButton>
          </Styled.ContentModalOTP>
        ) : (
          <Styled.ContentModalOTP>
            <Styled.TitleHeaderCode>
              <Typography variant="body2">
                {" "}
                <ArrowBackIcon />
                Finalizar Entrega
              </Typography>

              <Styled.ButtonClose
                onClick={() => {
                  setOpenModalFinallyOrder(false);
                  return onClose();
                }}
              />
            </Styled.TitleHeaderCode>

            <Styled.TitleBodyCodeOtp>
              <Typography variant="body2" style={{ width: "380px" }}>
                Para finalizar o pedido, digite o código informado pelo cliente
                no ato da entrega.
              </Typography>
            </Styled.TitleBodyCodeOtp>

            <OtpInput
              containerStyle={{
                marginBottom: "10%",
                alignSelf: "center",
              }}
              isInputNum
              inputStyle={{
                width: 40,
                height: 50,
                borderRadius: 8,
                borderWidth: 1,
              }}
              separator={<Styled.Separator />}
              value={otp}
              onChange={handleChange}
              numInputs={4}
            />

            <Styled.ButtonModalCodeOTP
              onClick={() => {
                setOpenModalFinallyOrderDescription(true);
              }}
            >
              Está sem o código de entrega?
            </Styled.ButtonModalCodeOTP>

            <Styled.ButtonModalCode
              onClick={() => {
                onConfirm({
                  origin: "DealerPortal",
                });
              }}
              disabled={otp?.length < 4}
              color="primary"
              variant="contained"
              size="large"
            >
              FINALIZAR PEDIDO
            </Styled.ButtonModalCode>
          </Styled.ContentModalOTP>
        )}
      </Modal>
    ) : (
      <SlideModal
        {...getOrderModalsProps(modalProps.type)}
        isOpen={!!modalProps}
        onClose={onClose}
        onConfirm={onConfirm}
      />
    );
  }, [
    modalProps,
    enabledPin,
    openModalFinallyOrderDescription,
    reasonNotProvidePin,
    otp,
    handleChange,
    dispatch,
    setOpenModalFinallyOrderDescription,
    setOpenModalFinallyOrder,
    closeOrderManagement,
  ]);

  const tabsNavigation = useMemo(() => {
    return (
      <TabsNavigation
        selectedTab={currentTab}
        tabs={[
          {
            label: `${t("newOrders")} (${typeOrders("New").length})`,
            icon: <ReceiptIcon />,
            value: "1",
          },
          {
            label: `${t("ordersInProgress")} (${
              typeOrders("InProgress").length
            })`,
            icon: <LocalShippingIcon />,
            value: "2",
          },
          {
            label: `${t("finishedOrders")} (${typeOrders("Finalized").length})`,
            icon: <CheckBoxIcon />,
            value: "3",
          },
        ]}
        onChangeTab={handleChangeTab}
        spaceAroundTabs
        tabStyle={{
          paddingLeft: 50,
          paddingRight: 50,
        }}
      />
    );
  }, [currentTab, t, typeOrders, handleChangeTab]);

  const handleSearchDealerByTerm = useCallback(async (term: string) => {
    try {
      setFoundDealers(null);
      setIsLoadingSearchDealerByTerm(true);
      const cleanedTerm = stripTaxDocumentMask(term);
      const { data } = await dealerCareApi.get(
        `v1/dealers/search?term=${cleanedTerm}&limit=100&offset=0`,
      );

      setFoundDealers(data.data);
    } catch {
      //
    } finally {
      setIsLoadingSearchDealerByTerm(false);
    }
  }, []);

  const CardsAccordionNew = useMemo(() => {
    return (
      <Styled.ContentHeader>
        {typeOrders("New").length > 0 &&
          typeOrders("New").map((order: any, index) => (
            <CardOrder
              ordersSelected={ordersSelected}
              indexSelected={index}
              key={order.id}
              data={order}
              handleOrderUpdate={() => {
                setOrdersSelected(index);
                return handleOrderUpdate;
              }}
            />
          ))}
      </Styled.ContentHeader>
    );
  }, [handleOrderUpdate, typeOrders, ordersSelected]);

  const CardsAccordionInProgress = useMemo(() => {
    return (
      <Styled.ContentHeader>
        {typeOrders("InProgress").map((order: any, index) => (
          <CardOrder
            ordersSelected={ordersSelected}
            indexSelected={index}
            key={order.id}
            data={order}
            handleOrderUpdate={() => {
              setOrdersSelected(index);
              return handleOrderUpdate;
            }}
          />
        ))}
      </Styled.ContentHeader>
    );
  }, [handleOrderUpdate, ordersSelected, typeOrders]);

  const CardsAccordionInFinalized = useMemo(() => {
    return (
      <Styled.ContentHeader>
        {typeOrders("Finalized").map((order: any, index) => (
          <CardOrder
            ordersSelected={ordersSelected}
            indexSelected={index}
            key={order.id}
            data={order}
            handleOrderUpdate={() => {
              setOrdersSelected(index);
              return handleOrderUpdate;
            }}
          />
        ))}
      </Styled.ContentHeader>
    );
  }, [handleOrderUpdate, ordersSelected, typeOrders]);

  const radioLabel = useCallback(
    (dealer: DealerResponse) => (
      <Box>
        {dealer.tradeName}
        <Box>{formatTaxDocument(dealer.taxpayerId)}</Box>
      </Box>
    ),
    [],
  );

  return (
    <Styled.Container>
      <SlideModal
        isOpen={isConfirmationModalVisible}
        onClose={handleChangeConfirmationModalVisibility}
        {...confirmationModalProps}
      />
      <Modal
        open={openModalCode && enabledPin === "true"}
        onClose={() => setOpenModalCode(false)}
        style={{
          zIndex: 1500,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Styled.ContentModal>
          <Styled.TitleHeaderCode>Atenção!</Styled.TitleHeaderCode>

          <Styled.TitleBodyCode>
            <Typography
              variant="subtitle2"
              textAlign="initial"
              sx={{ display: "inline" }}
            >
              Para a segurança da revenda e do cliente,{" "}
              <Typography
                component="span"
                variant="subtitle2"
                sx={{ fontWeight: "bold" }}
              >
                pedidos tipo VALE GÁS COLABORADOR OU PAGAMENTO ON-LINE
              </Typography>{" "}
              deverão ser finalizados mediante a um código de entrega gerado
              para o cliente. Lembre seus entregadores de pedir o código no
              momento de entrega!
            </Typography>
          </Styled.TitleBodyCode>

          <Styled.Image src={inputCode} />

          <Styled.ButtonModalCode
            onClick={() => {
              setOpenModalCode(false);
              localStorage.setItem("@ctech:firstAccessiWthoutRequest", "true");
            }}
            color="primary"
            variant="contained"
            size="large"
          >
            ENTENDI
          </Styled.ButtonModalCode>
        </Styled.ContentModal>
      </Modal>

      <Drawer
        anchor="right"
        open={ordersSelected !== null}
        onClose={() => {
          setOrdersSelected(null);
        }}
        PaperProps={{
          sx: {
            width: "100%",
            maxWidth: "600px",
            height: "100%",
          },
        }}
      >
        {ordersSelected !== null && (
          <Styled.ContainerDetais fullHeight>
            <CardOrderDetails
              openModalCode={() => setOpenModalCode(true)}
              fullHeight
              currentTab={currentTab}
              data={typeOrders(getOrderType(currentTab))[ordersSelected]}
              typeOrders={typeOrders}
              handleOrderUpdate={handleOrderUpdate}
              closeModal={() => setOrdersSelected(null)}
            />
          </Styled.ContainerDetais>
        )}
      </Drawer>

      <SwipeableDrawer
        anchor="right"
        open={isSwipeableOpen}
        onClose={() => handleCloseSwipeable(false)}
        onOpen={() => {}}
      >
        <Box
          sx={{
            width: 500,
            p: 5,
          }}
        >
          <Button
            onClick={() => handleCloseSwipeable(false)}
            variant="text"
            startIcon={<CloseIcon />}
            sx={{ mb: 4 }}
          >
            {t("close")}
          </Button>

          <Styled.SwipeableInputContainer
            onSubmit={handleSubmit((formData) =>
              handleSearchDealerByTerm(formData.reseller),
            )}
          >
            <Input
              name="reseller"
              label="Buscar por nome ou CNPJ da revenda"
              placeholder="Nome ou CNPJ"
              fullWidth
              sx={{ mr: 2 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              error={errors.reseller}
              register={register}
            />
            <Styled.ButtonSwipeable
              variant="contained"
              disabled={!resellerData}
              type="submit"
              loading={isLoadingSearchDealerByTerm}
            >
              {t("search")}
            </Styled.ButtonSwipeable>
          </Styled.SwipeableInputContainer>

          {!!foundDealers && !foundDealers?.length && (
            <Box sx={{ mt: 5 }}>Nenhuma revenda encontrada.</Box>
          )}
          {!!foundDealers?.length && (
            <Box>
              <FormControl sx={{ mt: 4 }}>
                <FormLabel sx={{ mb: 2 }}>Revendas encontradas</FormLabel>
                <RadioGroup value={tempSelectedDealer?.id}>
                  {foundDealers.map((dealer) => (
                    <FormControlLabel
                      key={dealer.id}
                      value={dealer.id}
                      control={
                        <Radio
                          onClick={(ev) =>
                            setTempSelectedDealer(() => {
                              const foundDealer = foundDealers.find(
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-ignore
                                (dlr) => dlr.id === ev.target.value,
                              );

                              return {
                                id: foundDealer?.id || "",
                                tradeName: foundDealer?.tradeName || "",
                              };
                            })
                          }
                        />
                      }
                      label={radioLabel(dealer)}
                      sx={{ mb: 1 }}
                    />
                  ))}
                </RadioGroup>
              </FormControl>

              <Styled.ButtonSwipeable
                variant="contained"
                sx={{ mt: 3, width: "100%" }}
                onClick={() => {
                  setSelectedDealer(tempSelectedDealer);
                  handleCloseSwipeable(!!tempSelectedDealer);
                }}
                disabled={!tempSelectedDealer}
              >
                Aplicar filtro
              </Styled.ButtonSwipeable>
            </Box>
          )}
        </Box>
      </SwipeableDrawer>
      {tabsNavigation}
      {modalRender}
      <Styled.ContainerHeader>
        <Styled.ContainerLeft>
          <Typography textAlign="center">
            {format(new Date(), "eeee", { locale: ptBR })}
            {", "}
            {format(new Date(Date()), "dd / MM / yyyy")}
          </Typography>
        </Styled.ContainerLeft>

        <Styled.ContainerRight>
          <Typography textAlign="center">
            {format(new Date(Date()), "HH:mm")}
          </Typography>
        </Styled.ContainerRight>

        <Button
          variant="text"
          startIcon={selectedDealer ? <CloseIcon /> : <FilterListIcon />}
          sx={{ ":hover": { backgroundColor: "unset" } }}
          onClick={
            selectedDealer
              ? () => {
                  setSelectedDealer(null);
                  handleCloseSwipeable();
                }
              : () => setIsSwipeableOpen(true)
          }
        >
          {selectedDealer ? "Remover filtro" : t("filter")}
        </Button>
      </Styled.ContainerHeader>
      {selectedDealer && (
        <Styled.ContainerHeader>
          <Typography textAlign="center">
            {selectedDealer?.tradeName}
          </Typography>
        </Styled.ContainerHeader>
      )}
      <Styled.ContainerOrdersKanban>
        <Styled.ContainerOrdersList onClick={() => setCurrentTab("1")}>
          {CardsAccordionNew}
        </Styled.ContainerOrdersList>
        <Styled.ContainerOrdersList onClick={() => setCurrentTab("2")}>
          {CardsAccordionInProgress}
        </Styled.ContainerOrdersList>
        <Styled.ContainerOrdersList onClick={() => setCurrentTab("3")}>
          {CardsAccordionInFinalized}
        </Styled.ContainerOrdersList>{" "}
      </Styled.ContainerOrdersKanban>
      {dataOrderModal && (
        <ModalOrderManagement
          data={dataOrderModal}
          isOpen={modal}
          handleOrderUpdate={handleOrderUpdate}
          onClose={() => setModal(!modal)}
          isView
        />
      )}
    </Styled.Container>
  );
};

export default OrderManagement;
